import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import InstagramIcon from "@material-ui/icons/Instagram";

const useStyles = makeStyles(() => ({
  root: {
    position: "fixed",
    inset: 0,
    zIndex: 1100,
    backgroundColor: "#f4f6f1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `
      linear-gradient(rgba(70,72,67,0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(70,72,67,0.05) 1px, transparent 1px)
    `,
    backgroundSize: "72px 72px",
    overflow: "hidden",
  },
  corner: {
    position: "absolute",
    width: 32,
    height: 32,
    borderColor: "rgba(70,72,67,0.2)",
    borderStyle: "solid",
  },
  cornerTL: {
    top: 28,
    left: 28,
    borderWidth: "1px 0 0 1px",
  },
  cornerTR: {
    top: 28,
    right: 28,
    borderWidth: "1px 1px 0 0",
  },
  cornerBL: {
    bottom: 28,
    left: 28,
    borderWidth: "0 0 1px 1px",
  },
  cornerBR: {
    bottom: 28,
    right: 28,
    borderWidth: "0 1px 1px 0",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: "0 2rem",
  },
  eyebrow: {
    fontFamily: "Futura, sans-serif",
    fontSize: "0.65rem",
    letterSpacing: "0.35em",
    textTransform: "uppercase",
    color: "#999",
    marginBottom: "2.5rem",
  },
  wordmark: {
    fontFamily: "Kefa, serif",
    fontWeight: 900,
    fontSize: "clamp(5rem, 18vw, 14rem)",
    lineHeight: 0.9,
    color: "#464843",
    letterSpacing: "-0.02em",
    userSelect: "none",
  },
  divider: {
    width: "100%",
    maxWidth: 480,
    height: 1,
    backgroundColor: "rgba(70,72,67,0.15)",
    margin: "2.5rem 0",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: 6,
      height: 6,
      borderRadius: "50%",
      backgroundColor: "rgba(70,72,67,0.25)",
    },
  },
  tagline: {
    fontFamily: "Futura, sans-serif",
    fontSize: "clamp(0.6rem, 1.5vw, 0.72rem)",
    letterSpacing: "0.28em",
    textTransform: "uppercase",
    color: "#999",
    marginBottom: "0.6rem",
  },
  constructionLabel: {
    fontFamily: "Futura, sans-serif",
    fontSize: "clamp(0.7rem, 2vw, 0.85rem)",
    letterSpacing: "0.22em",
    textTransform: "uppercase",
    color: "#464843",
    marginBottom: "2rem",
  },
  body: {
    fontFamily: "Futura, sans-serif",
    fontWeight: 100,
    fontSize: "clamp(0.78rem, 1.5vw, 0.9rem)",
    color: "#646565",
    letterSpacing: "0.05em",
    lineHeight: 1.8,
    maxWidth: 380,
  },
  socials: {
    display: "flex",
    gap: "1.4rem",
    marginTop: "2.8rem",
    alignItems: "center",
  },
  socialLink: {
    color: "#999",
    transition: "color 0.3s ease",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      color: "#464843",
    },
  },
  footer: {
    position: "absolute",
    bottom: 32,
    fontFamily: "Futura, sans-serif",
    fontSize: "0.6rem",
    letterSpacing: "0.3em",
    textTransform: "uppercase",
    color: "#999",
  },
}));

const UnderConstruction = () => {
  const c = useStyles();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={c.root}
      style={{
        opacity: visible ? 1 : 0,
        transition: "opacity 0.8s ease",
      }}
    >
      {/* Corner brackets */}
      <span className={`${c.corner} ${c.cornerTL}`} />
      <span className={`${c.corner} ${c.cornerTR}`} />
      <span className={`${c.corner} ${c.cornerBL}`} />
      <span className={`${c.corner} ${c.cornerBR}`} />

      <div className={c.content}>
        <Typography className={c.eyebrow}>
          Architecture &amp; Design
        </Typography>

        <span className={c.wordmark}>nafas</span>

        <div className={c.divider} />

        <Typography className={c.tagline}>Site under construction</Typography>

        <Typography className={c.constructionLabel}>
          Something remarkable is being built
        </Typography>

        <Typography className={c.body}>
          We are curating our new online presence.<br />
          In the meantime, reach us through our social channels.
        </Typography>

        <div className={c.socials}>
          <a
            href="https://instagram.com/naf.arch"
            target="_blank"
            rel="noopener noreferrer"
            className={c.socialLink}
            aria-label="Instagram"
          >
            <InstagramIcon style={{ fontSize: "1.4rem" }} />
          </a>
        </div>
      </div>

      <Typography className={c.footer}>nafas.design &nbsp;&mdash;&nbsp; 2026</Typography>
    </div>
  );
};

export default UnderConstruction;
